import { Component } from 'react';
import Loading from '../../../components/Loading';
import DomainImage from '../../../components/DomainImage';
import { withTranslation } from 'react-i18next';

class Domains extends Component {
    constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSelectDefault = this.onSelectDefault.bind(this);

        this.state = {
            domains: [],
            loading: false,
            defaultSelectedDomains: [],
        };
    }

    componentDidMount() {
        if (this.props.selectedAccount) {
            this.onSelectDefault();
        }
    }

    componentDidUpdate(prevProps) {
        if (
            JSON.stringify(prevProps.selectedAccount) !== JSON.stringify(this.props.selectedAccount)
        ) {
            this.onSelectDefault();
        }
    }

    onSelectDefault() {
        const defaultSelectedDomains = this.props.selectedAccount?.available_domains
            ?.filter((item) => this.props.domains?.find((domain) => item.siteUrl === domain.url))
            .map((item) => item.siteUrl);
        this.setState({
            defaultSelectedDomains,
            domains: defaultSelectedDomains,
        });
    }

    onChange(domain) {
        const domains = this.state.domains;
        const newDomains = domains.includes(domain)
            ? domains.filter((item) => item !== domain)
            : [...domains, domain];
        this.setState({
            domains: newDomains,
        });
    }

    onSubmit() {
        if (this.state.domains.length === 0) return this.props.handleNext();
        this.setState({
            loading: true,
        });
        const a = document.createElement('a');

        a.href = `/domains/link?account=${
            this.props.selectedAccount.account_id
        }&domains_url=${this.state.domains.join(',')}&dest=to_onboard`;
        a.click();
    }

    slectAll() {
        if (this.props.selectedAccount?.available_domains.length === this.state.domains.length) {
            this.setState({
                domains: this.state.defaultSelectedDomains,
            });
        } else {
            this.setState({
                domains: this.props.selectedAccount?.available_domains.map((item) => item.siteUrl),
            });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="padding-x-20">
                <div id="onboarding-general-settings">
                    <div className="customers-selects">
                        {!this.props.selectedAccount && (
                            <div className="customers-selects-item">
                                {t('onboarding.step_2.bar_header')}
                            </div>
                        )}
                        {this.props.selectedAccount &&
                            !this.props.selectedAccount?.available_domains?.length &&
                            t('onboarding.step_2.no_domains', {
                                account_email: this.props?.selectedAccount?.account_email,
                            })}
                        {!!this.props.selectedAccount?.available_domains?.length && (
                            <div className="customers-selects-item">
                                <div className="d-flex align-items-center">
                                    <input
                                        id="domain-all"
                                        type="checkbox"
                                        onChange={() => this.slectAll()}
                                        checked={
                                            this.props.selectedAccount?.available_domains.length ===
                                            this.state.domains.length
                                        }
                                    />
                                    <label htmlFor="domain-all">
                                        <span>{t('onboarding.step_2.select_all')}</span>
                                    </label>
                                </div>
                            </div>
                        )}
                        <div className="customers-selects-item-container">
                            {this.props.selectedAccount?.available_domains?.map((item) => (
                                <div key={item.siteUrl} className="customers-selects-item">
                                    <div className="d-flex align-items-center">
                                        <input
                                            id={`domain-${item?.siteUrl}`}
                                            type="checkbox"
                                            onChange={() => this.onChange(item?.siteUrl)}
                                            checked={this.state.domains.includes(item?.siteUrl)}
                                            disabled={this.state.defaultSelectedDomains.includes(
                                                item.siteUrl,
                                            )}
                                        />
                                        <label htmlFor={`domain-${item?.siteUrl}`}>
                                            <div className="customers-selects-item-img">
                                                <DomainImage domain_name={item.name} />
                                            </div>
                                            <span>{item?.siteUrl}</span>{' '}
                                        </label>
                                    </div>
                                    <span className="customers-selects-item-permission">
                                        {item?.permissionLevel}
                                    </span>
                                </div>
                            ))}
                        </div>
                        <div className="customers-selects-item d-flex justify-content-end">
                            <button
                                className="onboarding-skip-btn"
                                onClick={() => this.props.handleBack()}
                            >
                                {t('onboarding.back')}
                            </button>
                            <button
                                className="onboarding-btn-next"
                                onClick={this.onSubmit}
                                disabled={
                                    this.state.loading ||
                                    this.state.domains.length === 0 ||
                                    this.props.isDisabledNext
                                }
                            >
                                {this.state.domains.length === 0
                                    ? t('onboarding.next')
                                    : t('onboarding.save_and_next')}
                                {this.state.loading && <Loading onlyPreloader />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Domains);
